import { useTranslation } from 'react-i18next';
import { Box, Button, Hidden, IconButton, Stack, TextField, Typography, useTheme } from '@mui/material';
import CardComponent from '../../components/Card';
import { useState } from 'react';
import { AcceptIcon, CommunityMemberIcon, DeleteIcon, EditIcon, iconFontSize, RedoIcon, RejectIcon, SignOutIcon, TickIcon, ToggleActiveIcon, ToggleIcon } from '../../components/IconComponent';
import { GetIconColor } from '../../theme/main_style';
import Container from '../../components/Container';
import SubHeader from '../../components/SubHeader';
import { communityInvitationState } from '../../enums/contacts';
import { cache } from '../../utils/cache';
import WalletAllowanceController2 from '../my-plans/WalletAllowanceController2';

export default function CommunityMemberView(props) {
    const { t } = useTranslation();
    const { memberSelected, communitySelected, allowances} = props;
    const contactId = cache.getContact().id;
    const isOwner = communitySelected.ownerId === contactId;
    const { palette } = useTheme();
    const [newContactFirstName, setNewContactFirstName] = useState(memberSelected.contact.first_name);
    const [newContactLastName, setNewContactLastName] = useState(memberSelected.contact.last_name);
    const newContact = memberSelected.contact.id ? false : true;

    const onBack = () => {
        props.setActive("members")
    }
    
    const renderRoot = () => {
        return (
            <>
                <Hidden mdDown>
                    <Container showProcessing={props.showLoading} showFooter showHeader subHeader={<SubHeader title={communitySelected.group} variant={'action-buttons'} showBackIcon onGoBack={() => onBack()}/>}>
                        {renderContent()}
                    </Container>
                </Hidden>
                <Hidden mdUp>
                    <Container showProcessing={props.showLoading} mobileHeader={{
                        show: true,
                        title: communitySelected.group,
                        onBack: () => onBack(),
                    }}>
                        {renderContent()}
                    </Container>
                </Hidden>
            </>
        )
    }

    const renderContent = () => {
        let name = null;
        let identifier = null;
        if (memberSelected.contact && memberSelected.contact.first_name) 
        {
            name = memberSelected.contact.first_name;
            if(memberSelected.contact.last_name){
                name += " " + memberSelected.contact.last_name
            }
        }

        if(!name){
            if(memberSelected.contact.email){
                identifier = memberSelected.contact.email;
            }
            else if(memberSelected.contact.phone){
                identifier = memberSelected.contact.phone;
            }            
        }

        return (
            <>
                <Box
                    mb={1}
                    borderBottom={`1px solid ${palette.border.main}`}
                >
                    <CardComponent paddingY={1} noBorder paddingTop={0}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" alignItems="center">
                                <CommunityMemberIcon color={GetIconColor().default} size={iconFontSize.xxs} />
                                <Stack marginLeft={2} spacing={0} marginBottom={1}>
                                    {name ? 
                                        <Typography variant="subtitle1">{name}</Typography>:
                                        <Typography variant="subtitle1">{identifier}</Typography>}
                                    <Typography variant="subtitle2" style={{ opacity: 0.7, lineHeight: 0.5 }}>
                                        {memberSelected.state==communityInvitationState.PENDING ? t('pending') : t('member')}</Typography>
                                </Stack>
                            </Stack>
                           
                            <Hidden mdDown>
                                {memberSelected.state===communityInvitationState.ACCEPTED &&
                                <>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="flex-end"
                                        marginRight={2}
                                        width={"20%"}
                                    >
                                        {isOwner ?
                                            <Button sx={{ color:palette.common.white, borderRadius:'40px' }} fullWidth color='error' variant="contained" id="removeMember/Submit"
                                                onClick={() => props.onClickDeletePeople()} 
                                                startIcon={<DeleteIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                                {t('remove_member')}
                                            </Button> :
                                            <Button sx={{ color:palette.common.white, borderRadius:'40px' }} fullWidth color='error' variant="contained" id="leaveCommunity/Submit"
                                                onClick={() => props.onLeaveCommunity()} 
                                                startIcon={<SignOutIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                                {t('leave_community')}
                                            </Button>
                                        }

                                    </Stack>
                                </>
                                }
                            </Hidden>


                        </Stack>
                    </CardComponent>
                </Box>
                {memberSelected.state==communityInvitationState.PENDING && isOwner &&
                <>
                    {newContact &&
                    <>
                        <Typography marginTop={2} marginBottom={2}>{t('invite_new_member_desc')}</Typography>
                        <TextField
                            sx={{ marginBottom: 2 }}
                            id="outlined-controlled"
                            label={t("first_name")}
                            value={newContactFirstName}
                            onChange={(event) => {setNewContactFirstName(event.target.value)}}
                        />

                        <TextField
                            sx={{ marginBottom: 2 }}
                            id="outlined-controlled"
                            label={t("last_name")}
                            value={newContactLastName}
                            onChange={(event) => {setNewContactLastName(event.target.value)}}
                        />
                        </>
                    }

                    <Hidden mdDown>
                        {(memberSelected.contact.email || memberSelected.contact.phone) &&
                            <Box display="flex" justifyContent="center" width="100%" mb={2}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{ width: '80%' }}
                                >
                                    {memberSelected.contact.email &&
                                        <Button
                                            sx={{ flex: 1 }}
                                            color="primary"
                                            variant="contained"
                                            id="resendInvitationEmail/Submit"
                                            onClick={() => props.onClickResendInvitation("EMAIL", newContactFirstName, newContactLastName)}
                                            disabled={newContact && (!newContactFirstName || !newContactLastName)}
                                            startIcon={<RedoIcon color={GetIconColor().white} size={iconFontSize.xs} />}
                                        >
                                            {t('resend_invitation_email')}
                                        </Button>
                                    }
                                    {memberSelected.contact.phone &&
                                        <Button
                                            sx={{ flex: 1 }}
                                            color="primary"
                                            variant="contained"
                                            id="resendInvitationPhone/Submit"
                                            onClick={() => props.onClickResendInvitation("PHONE", newContactFirstName, newContactLastName)}
                                            disabled={newContact && (!newContactFirstName || !newContactLastName)}
                                            startIcon={<RedoIcon color={GetIconColor().white} size={iconFontSize.xs} />}
                                        >
                                            {t('resend_invitation_phone')}
                                        </Button>
                                    }
                                </Stack>
                            </Box>
                        }
                    </Hidden>



                    <Hidden mdUp>
                        {memberSelected.contact.email &&
                            <Stack direction="row" alignItems="center" justifyContent="center" marginBottom={2}>
                                <Button sx={{ width:'80%' }}  color="primary" variant="contained" id="resendInvitationEmail/Submit" borderRadius={'50%'}
                                    onClick={() => props.onClickResendInvitation("EMAIL", newContactFirstName, newContactLastName)} 
                                    disabled={newContact && (!newContactFirstName || !newContactLastName)}
                                    startIcon={<RedoIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('resend_invitation_email')}
                                </Button>
                            </Stack>}
                        {memberSelected.contact.phone &&
                            <Stack direction="row" alignItems="center" justifyContent="center" marginBottom={2}>   
                                <Button sx={{ width:'80%' }}  color="primary" variant="contained" id="resendInvitationPhone/Submit" borderRadius={'50%'}
                                    onClick={() => props.onClickResendInvitation("PHONE", newContactFirstName, newContactLastName)} 
                                    disabled={newContact && (!newContactFirstName || !newContactLastName)}
                                    startIcon={<RedoIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('resend_invitation_phone')}
                                </Button>
                            </Stack>}
                    </Hidden>

                        <Stack direction="row" alignItems="center" justifyContent="center" >
                            <Button sx={{ width:'80%',
                                backgroundColor: palette.error.main,
                                ':hover': {
                                    backgroundColor: palette.error.main,
                                }
                                }} variant="contained" id="deleteInvitation/Submit" borderRadius={'50%'}                           
                                    onClick={() => props.onClickDeleteInvitation()} 
                                    startIcon={<RejectIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('delete_invitation')}
                            </Button>
                        </Stack>   
                </>
                }

                {memberSelected.state==communityInvitationState.PENDING && !isOwner &&
                <>
                    <Stack direction="row" alignItems="center" justifyContent="center" marginRight={2}>
                        <Button sx={{ width:'80%',
                        backgroundColor: palette.success.main,
                        ':hover': {
                            backgroundColor: palette.success.main,
                        }
                        }} variant="contained" id="acceptInvitation/Submit" borderRadius={'50%'}
                            onClick={() => props.onClickAcceptRejectInvitation(true)} 
                            startIcon={<AcceptIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                            {t('accept_invitation')}
                        </Button>
                    </Stack>

                    <Stack direction="row" alignItems="center" justifyContent="center" marginRight={2} marginTop={2}>
                    <Button sx={{ width:'80%',
                        backgroundColor: palette.error.main,
                        ':hover': {
                            backgroundColor: palette.error.main,
                        }
                        }} variant="contained" id="rejectInvitation/Submit" borderRadius={'50%'}                           
                            onClick={() => props.onClickAcceptRejectInvitation(false)} 
                            startIcon={<RejectIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                            {t('reject_invitation')}
                        </Button>
                    </Stack>                    
                </>
                }

                {memberSelected.state==communityInvitationState.ACCEPTED && allowances &&
                <>
                    <WalletAllowanceController2
                        allowances={allowances}
                        readOnly={!isOwner}
                        memberSelected={memberSelected}
                        onRefresh={props.onRefresh}
                        setActive={props.setActive}
                    />
                </>
                }

                <Hidden mdUp>
                    {memberSelected.state==communityInvitationState.ACCEPTED &&
                    <>
                        <Stack direction="row" alignItems="center" justifyContent="center" sx={{position: 'fixed', bottom: '20px', left: 0, width: '100%', px: 2, zIndex: 1300 }}>
                            {isOwner ?
                                <Button sx={{ color:palette.common.white }} fullWidth color='error' variant="contained" id="removeMember/Submit" borderRadius={'50%'}
                                    onClick={() => props.onClickDeletePeople()} 
                                    startIcon={<DeleteIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('remove_member')}
                                </Button>
                                :
                                <Button sx={{ color:palette.common.white }} fullWidth color='error' variant="contained" id="leaveCommunity/Submit" borderRadius={'50%'}
                                    onClick={() => props.onLeaveCommunity()} 
                                    startIcon={<SignOutIcon color={GetIconColor().white} size= {iconFontSize.xs}/>}>
                                    {t('leave_community')}
                                </Button>
                            }
                        </Stack>
                    </>
                    }
                </Hidden>
        </>)
    }

    return (
        <>{renderRoot()}</>
    )
}
